import type { SVGProps } from 'react';

export function PawnIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 1c1.273 0 2.495.478 3.395 1.328A4.4 4.4 0 0 1 16.8 5.533a5.4 5.4 0 0 1-.526 2.268l.526-.001c.306 0 .6.11.823.31.222.198.356.469.374.757s-.082.572-.278.794a1.22 1.22 0 0 1-.778.398l-.14.008h-1.517l1.488 6.562c.067.29.01.593-.158.843a1.2 1.2 0 0 1-.738.498l-.136.023-.14.007H8.399a1.3 1.3 0 0 1-.485-.096 1.2 1.2 0 0 1-.402-.274 1.1 1.1 0 0 1-.251-.404 1.1 1.1 0 0 1-.057-.465l.021-.132 1.489-6.562H7.199c-.306 0-.6-.111-.823-.31A1.1 1.1 0 0 1 6.002 9a1.1 1.1 0 0 1 .278-.794c.196-.222.475-.364.779-.398l.14-.008h.526a5.6 5.6 0 0 1-.495-1.728l-.024-.294-.007-.245c0-1.202.506-2.355 1.406-3.205A4.95 4.95 0 0 1 12 1M18.858 19H5.143a1.23 1.23 0 0 0-.808.293A.94.94 0 0 0 4 20c0 .53.24 1.04.67 1.414.428.375 1.01.586 1.616.586h11.429c.56 0 1.1-.18 1.52-.506.418-.326.686-.775.75-1.262l.013-.174a.9.9 0 0 0-.067-.4 1 1 0 0 0-.242-.344 1.2 1.2 0 0 0-.379-.232 1.3 1.3 0 0 0-.452-.082" />
    </svg>
  );
}
